const initialstate = {
  fetching: null,
  fetchingSuccessful: null,
  fetchingFailed: null,
  error: null,
  errorText: null,
  conversations: null,
};

const getTestConversationsReducer = (state = initialstate, action) => {
  switch (action.type) {
    case 'FETCHING_TEST_CONVERSATIONS':
      return Object.assign({}, state, {
        fetching: true,
      });
    case 'FETCHING_TEST_CONVERSATIONS_DONE':
      return Object.assign({}, state, {
        fetching: false,
        fetchingSuccessful: true,
        fetchingFailed: false,
        error: false,
        errorText: '',
        conversations: action.payload,
      });
    case 'CREATING_TEST_CONVERSATION_DONE':
      return Object.assign({}, state, {
        conversations: Array.isArray(state.conversations)
          ? [action.payload, ...state.conversations]
          : [action.payload],
      });
    case 'UPDATING_TEST_CONVERSATION_DONE':
      return Object.assign({}, state, {
        conversations: Array.isArray(state.conversations)
          ? state.conversations.map((conv) =>
              conv.id === action.payload.id ? action.payload : conv,
            )
          : [action.payload],
      });
    case 'FETCHING_TEST_CONVERSATIONS_FAILED':
      return Object.assign({}, state, {
        fetching: false,
        fetchingSuccessful: false,
        fetchingFailed: true,
        error: true,
        errorText: action.payload,
        conversations: [],
      });
    default:
      return state;
  }
};

export default getTestConversationsReducer;
